import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close_page",
  "use": "icon-close_page-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-close_page\">\n<title>dele</title>\n<path d=\"M19.46 16.002l11.829-11.851c0.425-0.431 0.688-1.024 0.688-1.678s-0.263-1.247-0.688-1.679v0l-0.096-0.102c-0.431-0.427-1.025-0.691-1.68-0.691s-1.249 0.264-1.68 0.691v0l-11.829 11.874-11.829-11.874c-0.431-0.427-1.025-0.691-1.68-0.691s-1.249 0.264-1.68 0.691v0l-0.099 0.102c-0.438 0.426-0.709 1.020-0.709 1.678s0.272 1.253 0.709 1.678l0.001 0.001 11.829 11.852-11.829 11.851c-0.425 0.431-0.688 1.024-0.688 1.678s0.263 1.247 0.688 1.679v0l0.096 0.099c0.431 0.427 1.025 0.691 1.68 0.691s1.249-0.264 1.68-0.691l11.829-11.829 11.845 11.829c0.431 0.427 1.025 0.691 1.68 0.691s1.249-0.264 1.68-0.691l0.099-0.099c0.425-0.431 0.688-1.024 0.688-1.678s-0.263-1.247-0.688-1.679v0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/close_page.svg
// module id = 573u
// module chunks = 14